/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Payload to update an existing company.
 * @export
 * @interface UpdateCompanyRequest
 */
export interface UpdateCompanyRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateCompanyRequest
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCompanyRequest
     */
    domain?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCompanyRequest
     */
    address?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCompanyRequest
     */
    phone?: string | null;
}

/**
 * Check if a given object implements the UpdateCompanyRequest interface.
 */
export function instanceOfUpdateCompanyRequest(value: object): value is UpdateCompanyRequest {
    return true;
}

export function UpdateCompanyRequestFromJSON(json: any): UpdateCompanyRequest {
    return UpdateCompanyRequestFromJSONTyped(json, false);
}

export function UpdateCompanyRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateCompanyRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'domain': json['domain'] == null ? undefined : json['domain'],
        'address': json['address'] == null ? undefined : json['address'],
        'phone': json['phone'] == null ? undefined : json['phone'],
    };
}

export function UpdateCompanyRequestToJSON(json: any): UpdateCompanyRequest {
    return UpdateCompanyRequestToJSONTyped(json, false);
}

export function UpdateCompanyRequestToJSONTyped(value?: UpdateCompanyRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'domain': value['domain'],
        'address': value['address'],
        'phone': value['phone'],
    };
}

